/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { DOCUMENT_LIST } from "cms/documents/document/helpers";
import IconList from "./icon/icon";
import SimpleList from "./simple/simple-list";
import BulletPointList from "./bullet/bullet-point";
import AccordionList from "./accordion/accordion";

const DocumentListComponentDisplay = () => {
    
    const ctx = useContext(ContentZoneContext);
    const { component } = ctx || {};
    const { documents = [], listStyle } = component || {};
    const hasContent = documents?.length > 0;
    const isAccordion = listStyle === DOCUMENT_LIST.ACCORDION;
    const isSimpleList = listStyle === DOCUMENT_LIST.SIMPLE;
    const isBulletList = listStyle === DOCUMENT_LIST.BULLET;
    const isIconList = listStyle === DOCUMENT_LIST.ICON;
    
    return (
        <div className={`document-list-container ${isAccordion ? "accordion" : ""}`}>
            {hasContent &&
                <Fragment>
                    
                    {/*<div style={{backgroundColor: '#dedede', marginTop: '20px', marginBottom: '20px'}}>*/}
                    {/*    {listStyle}*/}
                    {/*</div>*/}
                    
                    {isSimpleList &&
                        <>
                            <SimpleList
                                component={component}
                            />
                        </>
                    }
                    
                    {isBulletList &&
                        <>
                            <BulletPointList
                                component={component}
                            />
                        </>
                    }
                    
                    {isAccordion &&
                        <>
                            <AccordionList
                                component={component}
                            />
                        </>
                    }
                
                    {isIconList &&
                        <>
                            <IconList
                                component={component}
                            />
                        </>
                    }
                
                </Fragment>
            }
            {!hasContent &&
                <EmptyContentMessage hasContent={hasContent} component={component} />
            }
        </div>
    );
};

DocumentListComponentDisplay.displayName = "DocumentListComponentDisplay";
export { DocumentListComponentDisplay };
